import React, { forwardRef } from 'react';
import { Link as HeroLink, LinkProps as HeroLinkProps } from '@heroui/react';

export interface CustomLinkProps extends HeroLinkProps {
  customAnchorIcon?: React.ReactNode;
}

const Link = forwardRef<HTMLAnchorElement, CustomLinkProps>(
  (
    {
      href = '#',
      size = 'md',
      color = 'primary',
      underline = 'hover',
      isExternal = false,
      isDisabled = false,
      isBlock = false,
      showAnchorIcon,
      anchorIcon,
      customAnchorIcon,
      children,
      className,
      ...rest
    },
    ref,
  ) => {
    return (
      <HeroLink
        ref={ref}
        href={href}
        size={size}
        color={color}
        underline={underline}
        isExternal={isExternal}
        isDisabled={isDisabled}
        isBlock={isBlock}
        showAnchorIcon={showAnchorIcon}
        anchorIcon={customAnchorIcon || anchorIcon}
        className={className}
        {...rest}
      >
        {children}
      </HeroLink>
    );
  },
);

Link.displayName = 'Link';
export default Link;
